// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { sampleTemplateId } from './SampleTemplate';
import { testTemplateId } from './TestTemplate';
import { z } from 'zod';
export const sampleTemplateTestId = (z.number());
export const sampleTemplateTest = z.object({
    id: sampleTemplateTestId,
    sample_template_id: sampleTemplateId,
    test_template_id: testTemplateId,
    is_mandatory: z.boolean(),
});
export const sampleTemplateTestInitializer = z.object({
    id: sampleTemplateTestId.optional(),
    sample_template_id: sampleTemplateId,
    test_template_id: testTemplateId,
    is_mandatory: z.boolean().optional(),
});
export const sampleTemplateTestMutator = z.object({
    id: sampleTemplateTestId.optional(),
    sample_template_id: sampleTemplateId.optional(),
    test_template_id: testTemplateId.optional(),
    is_mandatory: z.boolean().optional(),
});
//# sourceMappingURL=SampleTemplateTest.js.map